import { render } from "./Index.vue?vue&type=template&id=7559c3d8&scoped=true&bindings={\"toList\":\"setup\",\"buttonItems\":\"setup\",\"kihon\":\"setup\",\"others\":\"setup\",\"infoItem\":\"setup\"}"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=7559c3d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7559c3d8"

export default script